import Lemonade1 from '../../../media/GW/Lemonade.webp'
import Lemonade2 from '../../../media/GW/Lemonade.webp'

const Lemonadeimages =[
Lemonade1,Lemonade2
]

export default Lemonadeimages;